<template>
    <div v-if="!isTakingEvaluationAction">
        <slot :skip="skip" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'

export default {
    components: { Spinner },

    computed: {
        ...mapGetters('athleteProfile', ['isTakingEvaluationAction']),
    },

    methods: {
        ...mapActions('athleteProfile', ['skip']),
    },
}
</script>